import { useState } from "react";
import { dismissAddPeople, isAddPeopleDismissed } from "./addPeopleOffer";

/**
 * KEY-751: "Who's on this dial?" — offered to a dial admin when the dial picks people (an appointment's "Who it's
 * for") but Who's who is empty. "Add people" opens Who's who; "Not now" hides it in this browser. Looks like the
 * follow prompt beside it, so the two read as the same kind of one-off question.
 */
export function AddPeoplePrompt({ instanceId, onAdd }: { instanceId: string; onAdd: () => void }) {
  const [dismissed, setDismissed] = useState(() => isAddPeopleDismissed(instanceId));
  if (dismissed) {
    return null;
  }

  return (
    <div
      className="kd-card"
      role="region"
      aria-label="Add the people on this dial"
      style={{ padding: "var(--pad-card, 16px)", margin: "0 0 14px", borderLeft: "3px solid var(--accent)" }}
    >
      <div style={{ fontSize: 14.5, fontWeight: 700, color: "var(--text)" }}>Who's on this dial?</div>
      <p style={{ margin: "6px 0 12px", fontSize: 13.5, lineHeight: 1.5, color: "var(--text-muted)" }}>
        Add the people this dial is for — your family, say — and you can pick them when you add an appointment or a
        to-do. You can change the list any time from the dial's settings, under Who's who.
      </p>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <button onClick={onAdd} className="kd-btn-primary" style={{ fontSize: 13 }}>
          Add people
        </button>
        {/* kd-btn-dashed is the full-width "add" button; sized to its label here, as a secondary answer. */}
        <button
          onClick={() => {
            dismissAddPeople(instanceId);
            setDismissed(true);
          }}
          className="kd-btn-dashed"
          style={{ fontSize: 13, width: "auto", padding: "8px 16px" }}
        >
          Not now
        </button>
      </div>
    </div>
  );
}
